export default "__VITE_ASSET__C1Zk7wn8__"